import React, { Component } from 'react'
import { ErrorMessage, emptyField, errorsLength, formatErrors, searchCEP, validateCEP, validatePositiveNumber } from '../../../../../insfrastructure/utils/form-validators'
import { listJobTitles } from '../../../../../insfrastructure/services/jobs-titles'
import { StaticValues } from '../../../../../insfrastructure/services/static_values'
import { listCompanies } from '../../../../../insfrastructure/services/companies'
import { TokenParams } from '../../../../../insfrastructure/services/auth'
import { parseJwt } from '../../../../../insfrastructure/utils/JWTParser'
import { getAuthToken } from '../../../../../insfrastructure/services/token-manager'
import { Input } from '../../../../components/input'
import { Select } from '../../../../components/select'
import CheckboxInput from '../../../../components/checkbox'
import pcdImg from '../../../../../assets/icons/pcd.png'
// import locationImg from '../../../../../assets/icons/location.png'
import './styles.sass'

interface Props {
  inital_data?: any,
  is_editing?: boolean,
  onSubmit: (data: any) => void
}

export interface BasicInfoForm {
  job_title_id: number,
  job_type: string,
  inclusive_job: boolean,
  quantity: number,
  job_description: string,
  company_id?: number
}

interface State {
    form: BasicInfoForm,
    formErrors: Record<string, any>,
    job_titles: Record<string, any>[],
    job_types: Record<string, any>[],
    company_options: Record<string, any>[],
    loading_company_options: boolean,
    em_job_manager: boolean
}

export default class BasicInfo extends Component<Props> {
  state: State = {
    form: {
      job_title_id: 0,
      job_type: '',
      inclusive_job: false,
      quantity: 1,
      job_description: ''
    },
    formErrors: {},
    job_titles: [],
    job_types: [],
    company_options: [],
    loading_company_options: false,
    em_job_manager: false
  }
  timeout: any = null

  componentDidMount() {
    if(this.props.inital_data.job_title_id && !this.state.form.job_title_id) {
      this.setState({ form: this.props.inital_data });
      this.onCompanyNameSearch(this.props.inital_data.company_name);
    };
    this.validateEMUser();
    this.getStaticValues();
    this.listJobTitles();
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
    if(this.props.inital_data.job_title_id && !this.state.form.job_title_id) {
      this.setState({ form: this.props.inital_data });
      this.onCompanyNameSearch(this.props.inital_data.company_name);
    };
  }

  validateEMUser = async () => {
    try {
      const authToken = getAuthToken();
      if (!authToken) return;
      
      const parsedJWT: TokenParams = parseJwt(authToken);
      
      this.setState({ em_job_manager: parsedJWT.profiles.includes('em_job_manager') });
    } catch (error) {}
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;          
      const job_types = Object.keys(staticValues.job_type)
        .map(key => ({ value: key, label: staticValues.job_type[key] }))
        .sort((a, b) => a.label.localeCompare(b.label));
      
      this.setState({ job_types });
    } catch (error) {}
  }

  listJobTitles = async () => {
    try {
      const response = await listJobTitles();
      
      const jobTitles = response.results
        .map(item => ({ value: item.id, label: item.name }))
        .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
      
      this.setState({ job_titles: jobTitles });
    } catch (error) {
      console.log(error);
    }
  }

  companiesSearchTimeout: any = null

  onCompanyNameSearch = async (e: any) => {
    clearTimeout(this.companiesSearchTimeout);

    // Proteção contra undefined/null - garante que sempre temos uma string
    const searchValue = e || '';
    if (searchValue.length < 3) {
      return;
    };

    this.setState({ loading_company_options: true }, async () => { 
      this.companiesSearchTimeout = setTimeout(async () => {
          const companies = (await listCompanies({ search: searchValue, page: 1 })).data;
          const company_options = companies.map(x => ({ value: x.companyId, label: x.name }));

          this.setState({ company_options, loading_company_options: false });
      }, 1000);
    });
  }

  onQuantityKeyDown = (e: React.KeyboardEvent) => {
    // Permitir: backspace, delete, tab, escape, enter, setas, home, end
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    
    // Permitir Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (e.ctrlKey || e.metaKey) {
      if (['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
        return;
      }
    }
    
    // Se a tecla estiver na lista de permitidas, deixar passar
    if (allowedKeys.includes(e.key)) {
      return;
    }
    
    // Permitir números (1-9) - não permitir 0
    if (e.key >= '1' && e.key <= '9') {
      return;
    }
    
    // Bloquear zero se o campo estiver vazio (para não permitir começar com 0)
    const currentValue: any = this.state.form.quantity;
    const isEmpty = currentValue === null || currentValue === undefined || 
                    currentValue === '' || (typeof currentValue === 'string' && currentValue.trim() === '');
    if (e.key === '0' && isEmpty) {
      e.preventDefault();
      return;
    }
    
    // Permitir zero apenas se já houver um número antes (ex: 10, 20, etc)
    if (e.key === '0' && !isEmpty) {
      return;
    }
    
    // Bloquear todas as outras teclas (incluindo '-', 'e', 'E', '+', '.', etc)
    e.preventDefault();
  }

  onQuantityChange = (value: string | number | null | undefined) => {
    // Se o campo estiver vazio, permitir temporariamente durante a digitação
    if (value === '' || value === null || value === undefined) {
      this.setState({ form: { ...this.state.form, quantity: '' } });
      return;
    }
    
    // Converter para número (e.target.value sempre retorna string, mesmo em type='number')
    const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
    
    // Apenas atualizar se for um número válido maior ou igual a 1
    // O onKeyDown já garante que apenas números válidos sejam digitados
    if (!isNaN(numValue) && numValue >= 1) {
      this.setState({ form: { ...this.state.form, quantity: numValue } });
    }
  }

  onSubmit = async () => {
    let field_validations: Record<string, any> = {
      job_title_id: [emptyField(this.state.form.job_title_id, 'string')],
      job_type: [emptyField(this.state.form.job_type, 'string')],
      quantity: [validatePositiveNumber(this.state.form.quantity)],
      // cep: [validateCEP(this.state.form.cep)],
      // uf: [emptyField(this.state.form.uf, 'string')],
      // city: [emptyField(this.state.form.city, 'string')],
      // neighborhood: [emptyField(this.state.form.neighborhood, 'string')],
      // street: [emptyField(this.state.form.street, 'string')],
      // number: [emptyField(this.state.form.number, 'string')],
      job_description: [emptyField(this.state.form.job_description, 'string')]
    };

    if (this.state.em_job_manager) {
      field_validations['company_id'] = [emptyField(this.state.form.company_id, 'number')];
    };

    const errors = formatErrors(field_validations);

    // if(errors['cep'].length === 0) {
    //   const result = await searchCEP(this.state.form.cep);
    //   if(result.erro === 'true') {
    //     errors.cep = ['CEP inválido'];
    //   };
    // };

    this.setState({ formErrors: errors }, () => {
      if (errorsLength(errors) > 0) {
        const firstErrorElement = document.querySelector('.errors .error') as HTMLElement | null;
        if (firstErrorElement && typeof firstErrorElement.scrollIntoView === 'function') {
          firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });

    if(errorsLength(errors) > 0) return;

    this.props.onSubmit(this.state.form);
  }

  onCEPChange = async (value: any) => {
    clearTimeout(this.timeout);
    
    this.timeout = setTimeout(async () => {
      let uf = '';
      let city = '';
      let neighborhood = '';
      let street = '';

      if(validateCEP(value) === '') {
        const result = await searchCEP(value);
        uf = result.uf;
        city = result.localidade;
        neighborhood = result.bairro;
        street = result.logradouro;
      };
  
      this.setState({
        form: {
          ...this.state.form,
          uf,
          city,
          neighborhood,
          street
        }
      });
    }, 500);
  }

  render() {
    return (
      <div className='basic-info'>
        <div className='columns'>
          <div className='column'>
            {
            this.state.em_job_manager &&  
            <div>
              {this.props.is_editing ? (
                <div className="readonly-field">
                  <label>Empresa:</label>
                  <div className="readonly-value">
                    <span>{this.props.inital_data?.company_name || 'Empresa não informada'}</span>
                  </div>
                  <div className="readonly-warning">
                    <span>⚠️ A empresa não pode ser alterada durante a edição</span>
                  </div>
                </div>
              ) : (
                <>
                  <Select
                  name='company_id'
                  label='Empresa'
                  options={this.state.company_options}
                  value={this.state.form.company_id}
                  hasSearch={true}
                  loading={this.state.loading_company_options}
                  onSearchChange={e => this.onCompanyNameSearch(e)}
                  onChange={e => this.setState({ form: { ...this.state.form, company_id: e }, formErrors: { ...this.state.formErrors, company_id: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['company_id']} />
                </>
              )}
            </div>}
            <Select
            name='job_title_id'
            label='Vaga'
            value={this.state.form.job_title_id}
            options={this.state.job_titles}
            onChange={e => this.setState({ form: { ...this.state.form, job_title_id: e }, formErrors: { ...this.state.formErrors, job_title_id: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['job_title_id']} />
            <Select
            name='job_type'
            label='Tipo'
            value={this.state.form.job_type}
            options={this.state.job_types}
            onChange={e => this.setState({ form: { ...this.state.form, job_type: e }, formErrors: { ...this.state.formErrors, job_type: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['job_type']} />
            {/* <div className='location-section'>
              <div className='location-title'>
                <img src={locationImg} alt='location'/>
                <h4>Localização</h4>
              </div>
              <Input
              name='cep'
              label='CEP'
              mask='99999-999'
              value={this.state.form.cep}
              onChange={e => { this.setState({ form: { ...this.state.form, cep: e } }); this.onCEPChange(e); }}/>
              <ErrorMessage errors={this.state.formErrors['cep']} />
              <div className='address-info'>
                <p>Rua: <b>{this.state.form.street ? this.state.form.street : '-'}</b></p>
                <p>Bairro: <b>{this.state.form.neighborhood ? this.state.form.neighborhood : '-'}</b></p>
                <p>Cidade: <b>{this.state.form.city ? this.state.form.city : '-'}</b></p>
                <p>UF: <b>{this.state.form.uf ? this.state.form.uf : '-'}</b></p>
              </div>
              <div className='columns'>
                <div className='column'>
                  <Input
                  name='number'
                  label='Número'
                  value={this.state.form.number}
                  onChange={e => this.setState({ form: { ...this.state.form, number: e } })}/>
                  <ErrorMessage errors={this.state.formErrors['number']} />
                </div>
                <div className='column'>
                  <Input
                  name='complement'
                  label='Complemento'
                  value={this.state.form.complement}
                  onChange={e => this.setState({ form: { ...this.state.form, complement: e } })}/>
                </div>
              </div>
            </div> */}
            <Input
            name='quantity'
            type='number'
            label='Quantidade de vagas'
            value={this.state.form.quantity}
            min={1}
            onChange={e => { this.onQuantityChange(e); this.setState({ formErrors: { ...this.state.formErrors, quantity: [] } }); }}
            onKeyDown={e => this.onQuantityKeyDown(e)}/>
            <ErrorMessage errors={this.state.formErrors['quantity']} />
            <CheckboxInput
            name='inclusive_job'
            checked={this.state.form.inclusive_job}
            label={
              () => 
                <div className='pcd-check'>
                  <p>Vaga para Pessoa com Deficiência (PcD)</p>
                  <img src={pcdImg} alt='pcd'/>                  
                </div>
            }
            onChange={e => this.setState({ form: { ...this.state.form, inclusive_job: e } })}/>
          </div>
          <div className='column descripiton-column'>
            <Input
            name='job_description'
            type='textarea'
            label='Descrição'
            value={this.state.form.job_description}
            onChange={e => this.setState({ form: { ...this.state.form, job_description: e }, formErrors: { ...this.state.formErrors, job_description: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['job_description']} />
          </div>
        </div>
        <button className='primary' onClick={this.onSubmit}>Confirmar</button>
      </div>
    )
  }
}
